import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "settings/organization_settings/regions"
});

export const api = {
  getRegions(params) {
    return instance.get("", params);
  },
  addRegion(params) {
    return instance.post("", params);
  },
  updateRegion(id, params) {
    return instance.put(`/${id}`, params);
  },
  setAsDefault(params) {
    return instance.post("/set_as_default", params);
  },
  removeRegion(params) {
    return instance.delete("/", params);
  }
};
